//Imports
import Timeline from './timeline';
import Common from './common';
import Home from './home';
import Article from './article';
import Page from './page';
import PopIn from './popin';
import Search from './search';
import Contact from './contact';
import Presse from './presse';
import Petition from './petition';
import Revue from './revue';
import Adherent from './adherent';
import Newsletter from './newsletter';

// Utilisation de $ pour Jquery
window.$ = jQuery
let bodyClasses = document.body.classList;

// Message navigateur obsolète
function $buo_f() {
  let e = document.createElement('script');
  e.src = '//browser-update.org/update.min.js';
  document.body.appendChild(e)
}

try {
  document.addEventListener('DOMContentLoaded', $buo_f, false)
}
catch (e) {
  window.attachEvent('onload', $buo_f)
}

$(document).ready(function () {
  if (document.body.classList.contains('imce-page')) {
    return;
  }
  // Initialisation de la classe Common, utilisée pour tout le site
  new Common();
  new PopIn();
  new Presse();
  new Adherent().loginAdherent();
  new Newsletter();
  if (bodyClasses.contains('path-frontpage')) {
    new Home();
  } else if (bodyClasses.contains('page-node-type-article') || bodyClasses.contains('page-node-type-campagne')) {
    let article = new Article();
    article.CurrentArticle();
    if (document.querySelector('#timeline-slider')) {
      new Timeline();
    }
  } else if (bodyClasses.contains('path-espace-perso')) {
    new Adherent().sideBarAbonnements();
  } else if (bodyClasses.contains('path-contact')) {
    new Contact();
  } else if (bodyClasses.contains('path-search')) {
    new Search();
  } else if (bodyClasses.contains('page-node-type-page')) {
    new Page();
  } else if (bodyClasses.contains('page-node-type-qui-sommes-nous')) {
    if (document.querySelector('#timeline-slider')) {
      new Timeline();
    }
  } else if (bodyClasses.contains('path-revue-des-parents')) {
    let revue = new Revue();
    revue.slideshowRevues();
  } else if (bodyClasses.contains('page-node-type-petition') || bodyClasses.contains('path-petitions')) {
    new Petition();
  } else if (bodyClasses.contains('path-fcpe-adherent')) {
    $('#reset-password-form-adherent').validationEngine('attach', {
      promptPosition: "topLeft",
      scroll: false
    });
  }
});
